import dayjs from 'dayjs';
import { QSelect } from '@kw/quokka-ui';

interface IProps {
  title: string;
  label: string;
  stateValue: string;
  handleDateRangeChange: (event: React.ChangeEvent<{ value: string }>, type: string) => void;
}

export default function DeviceOwnersDateRangeSelect({ title, label, stateValue, handleDateRangeChange }: IProps) {
  // using 1 day in future to account for timestamps < 24 hours
  const tomorrow = dayjs().add(1, 'day').toISOString().split('T')[0];
  const lastWeek = dayjs(tomorrow).subtract(7, 'day').toISOString().split('T')[0];
  const lastMonth = dayjs(tomorrow).subtract(30, 'day').toISOString().split('T')[0];
  // hardcoding safe start date for greater than 30 days
  const startDate = dayjs('2022-01-01').toISOString().split('T')[0];

  const dateRange = [
    {
      label: 'All',
      value: 'all',
    },
    {
      label: 'Last 7 days',
      value: `${lastWeek}:${tomorrow}`,
    },
    {
      label: 'Last 30 days',
      value: `${lastMonth}:${tomorrow}`,
    },
    {
      label: 'Greater than 30 days',
      value: `${startDate}:${tomorrow}`,
    },
  ];

  return (
    <QSelect
      size="medium"
      options={dateRange}
      value={stateValue}
      onChange={e => handleDateRangeChange(e, label)}
      label={`${title}:`}
      formControlProps={{ sx: { width: '20%' } }}
      selectIconProps={{ fontSize: 'large' }}
    />
  );
}
